import { lazy, Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import App from '~/App';

const LoginPage = lazy(() => import('../pages/LoginPage'));
const Dashboard = lazy(() => import('../pages'));
const AuthOkta = lazy(() => import('../pages/LoginPage/AuthOkta'));
const AuthOktaCallback = lazy(() => import('../pages/LoginPage/AuthOktaCallback'));
const LoginWithToken = lazy(() => import('../pages/LoginPage/LoginWithToken'));

export const Router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<App />}>
      <Route
        path="/"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/login"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginPage />
          </Suspense>
        }
      />
      <Route
        path="/auth/okta"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <AuthOkta />
          </Suspense>
        }
      />
      <Route
        path="/auth/okta-callback"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <AuthOktaCallback />
          </Suspense>
        }
      />
      <Route
        path="/auth/:token"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <LoginWithToken />
          </Suspense>
        }
      />
      <Route
        path="/*"
        element={
          <Suspense fallback={<LoadingCircularProgress open />}>
            <Dashboard />
          </Suspense>
        }
      />
    </Route>
  )
);
